import React, { useState } from "react";

import { ApiUseList } from "./";

export default function ApiUseManagement() {
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const reqData = {};

  return (
    <div>
      <ApiUseList
        loading={loading}
        refresh={refresh}
        requestInfo={{
          url: `/retrieve-api-uses/`,
          data: reqData,
        }}
      />
    </div>
  );
}
